var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.compId,{tag:"component",attrs:{"params":_vm.params}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-365007cf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/views/systemSet/org/user.vue
// module id = 1198
// module chunks = 0 1